import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

export default function PolicyPage({ slug }) {
  const { lang } = useLang();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/policies/${slug}`).then((r) => setP(r.data)).catch(() => setP(null)); }, [slug]);
  if (!p) return null;
  const es = lang === "es";
  const title = es ? p.title_es : p.title_en;
  return (
    <div className="mx-auto max-w-3xl px-6 lg:px-12 py-16" data-testid={`policy-${slug}`}>
      <h1 className="text-3xl sm:text-4xl font-normal text-charcoal-800 mb-2">{title}</h1>
      <p className="text-xs text-charcoal-400 mb-8">{es ? "Última actualización" : "Last updated"}: {p.updated_at ? new Date(p.updated_at).toLocaleDateString() : p.version} · v{p.version}</p>
      <div className="space-y-6">
        {(p.sections || []).map((sec, i) => (
          <section key={i} data-testid={`policy-section-${i}`}>
            <h2 className="text-lg font-medium text-charcoal-800 mb-1">{es ? sec.h_es : sec.h_en}</h2>
            <p className="text-charcoal-600 leading-relaxed">{es ? sec.b_es : sec.b_en}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
